// libs
import React, { memo } from 'react';

// styles
import {
  Container,
  ImageContainer,
  Image,
  Tags,
  Title,
  SubTitle,
  Rating,
  Separator,
  SizeHeading,
  Sizes,
  SizeOptions,
} from './styles';

function Placeholder() {
  return (
    <Container>
      <ImageContainer>
        <Image />
        <Image />
      </ImageContainer>
      <Tags />
      <Title />
      <SubTitle />
      <Rating />

      <Separator />

      <SizeHeading />
      <Sizes>
        {Array.from(Array(5)).map((_, i) => {
          return <SizeOptions key={`placeholder-size-option-${i}`}></SizeOptions>;
        })}
      </Sizes>
    </Container>
  );
}

export default memo(Placeholder);
